import React from 'react';

function NoticePage() {
    return (
        <div>
            <h2>고객센터</h2>
            공지사항
            <div>게시판 내용</div>
        </div>
    );
}

export default NoticePage;
